import { render } from "./ZhaiFoot.vue?vue&type=template&id=7193629a&scoped=true"
import script from "./ZhaiFoot.vue?vue&type=script&lang=js"
export * from "./ZhaiFoot.vue?vue&type=script&lang=js"

import "./ZhaiFoot.vue?vue&type=style&index=0&id=7193629a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7193629a"]])

export default __exports__